import React from 'react';

const SampleSizeIndicator = ({ sampleSize, isLowSampleSize, crossLabelAnalysis, onExport }) => {
  return (
    <>
        {crossLabelAnalysis && crossLabelAnalysis.name !== "" && (
            <div className="pivot-sample-container">
                <div className="sample-size">Cross-label analysis {crossLabelAnalysis.name} : {crossLabelAnalysis.count} out of {crossLabelAnalysis.totalVerbatimsCount} verbatims match the filters, representing {crossLabelAnalysis.percentage}%</div>
            </div>
        )}
        <div className="pivot-sample-container">
            <div className={`sample-size ${isLowSampleSize ? "low" : ""}`}>
                {isLowSampleSize
                ? `Sample size is low (${sampleSize} conversations). Interpret data with caution.`
                : `Sample size : ${sampleSize} conversations`}
            </div>
            <button
                className="icon-button export-button"
                onClick={onExport}
                title="Export Data"
            >
                <i className="fa-solid fa-download"></i>
            </button>
        </div>
    </>
  );
}

export default SampleSizeIndicator;
